// region Imports
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import _ from "lodash";
import moment from "moment";
import creditCardType from "credit-card-type";
import { Translate, I18n } from "react-redux-i18n";
import WizardActionButtons from "../../Wizard/WizardActionButtons";
import { toggleBlockingStatus } from "../../../Store/Status/Actions";
import { getXsrfToken } from "../../../Store/Security/Actions";
import { selectPaymentMethod, updateCustomerAgreement, paymentFailed, resetCurrentApprovalCode, updateProductAgreement, updateRentalAgreement } from "../../../Store/Checkout/Actions";
import Utilities from "../../../Helpers/Utilities";
// endregion

class PaymentMethodForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedPaymentMethod: null,
            cardType: "visa",
            canComplete: false,
            canCompleteAgreement: false,
            canCompleteRentalAgreement: false,
            termsChecked: false,
            productTermsChecked: false,
            rentalTermsChecked: false
        };

        this.normalizeCreditCard = this.normalizeCreditCard.bind(this);
        this.normalizeCvv = this.normalizeCvv.bind(this);
        this.responseHandler = this.responseHandler.bind(this);
        this.makeIntuitRequest = this.makeIntuitRequest.bind(this);
        this.onTermsChange = this.onTermsChange.bind(this);
        this.onProductTermsChange = this.onProductTermsChange.bind(this);
        this.onRentalTermsChange = this.onRentalTermsChange.bind(this);
        this.renderCheckBoxField = this.renderCheckBoxField.bind(this);
        this.renderProductAgreementCheckBoxField = this.renderProductAgreementCheckBoxField.bind(this);
        this.renderRentalAgreementCheckBoxField = this.renderRentalAgreementCheckBoxField.bind(this);
    }

    componentWillMount() {
        this.resetForm();
    }

    componentDidMount() {
        const { change, userInfo } = this.props;
        const termsElement = document.getElementById("terms");
        const productTermsElement = document.getElementById("productTerms");
        const rentalTermsElement = document.getElementById("rentalTerms");

        if (termsElement) {
            change("Terms", userInfo.agreementChecked);
            termsElement.checked = userInfo.agreementChecked;
            this.setState({ termsChecked: userInfo.agreementChecked });
        }
        if (productTermsElement) {
            change("ProductTerms", userInfo.productAgreementChecked);
            productTermsElement.checked = userInfo.productAgreementChecked;
            this.setState({ productTermsChecked: userInfo.productAgreementChecked });
        } else {
            this.setState({ canCompleteAgreement: true });
        }
        if (rentalTermsElement) {
            change("RentalTerms", userInfo.rentalAgreementChecked);
            rentalTermsElement.checked = userInfo.rentalAgreementChecked;
            this.setState({ rentalTermsChecked: userInfo.rentalAgreementChecked });
        } else {
            this.setState({ canCompleteRentalAgreement: true });
        }
    }

    componentWillUnmount() {
        const { resetCurrentApprovalCode } = this.props;

        resetCurrentApprovalCode();
    }

    renderPaymentMethods() {
        const { paymentMethods } = this.props;

        if (paymentMethods && paymentMethods.length > 0) {
            // return _.map(paymentMethods, (paymentMethod, i) => (
            //     <div key={i} className="input-radio input-radio--innerlabel">
            //         <input id={`radio-${i}`} type="radio" name="radio" value={paymentMethod.paymentMethodSystemName}/>
            //         <label htmlFor={`radio-${i}`}>{paymentMethod.name}</label>
            //     </div>
            // ));

            return _.map(paymentMethods, (paymentMethod, i) => {
                let paymentMethodName;

                switch (paymentMethod.paymentMethodSystemName) {
                case "Payments.PurchaseOrder":
                    paymentMethodName = I18n.t("bankAccount.title");
                    break;
                case "Payments.Manual":
                    paymentMethodName = I18n.t("creditCard.title") + " (+" + paymentMethod.fee + ")";
                    break;
                }

                return (
                    <div key={i} className="col-md-6 text-center">
                        <div className="input-radio">
                            <span className="input__label">{paymentMethodName}</span>
                            <Field id={`radio-${i}`} type="radio" name="paymentMethod" value={paymentMethod.paymentMethodSystemName} component="input" onChange={e => this.onPaymentMethodSelect(e.target.value)}/>
                            <label htmlFor={`radio-${i}`}/>
                        </div>
                    </div>
                );
            });
        }
    }

    resetForm() {
        const { paymentFailed, change, untouch } = this.props;

        change("paymentMethod", "");
        change("CardholderName", "");
        change("CardNumber", "");
        change("CardCode", "");
        change("ExpireMonth", "1");
        change("ExpireYear", moment().format("YYYY"));
        change("RoutingNumber", "");
        change("AccountNumber", "");
        change("NameOnAccount", "");
        change("AccountType", "checking");

        untouch("CardholderName");
        untouch("CardNumber");
        untouch("CardCode");
        untouch("ExpireMonth");
        untouch("ExpireYear");
        untouch("RoutingNumber");
        untouch("AccountNumber");
        untouch("NameOnAccount");
        untouch("AccountType");

        paymentFailed({});
    }

    renderYears() {
        const options = [];

        for (let i = 0; i < 8; i++) {
            const year = moment().add(i, "year").format("YYYY");

            options.push(<option key={year} value={year}>{year}</option>);
        }

        return options;
    }

    renderMonths() {
        const options = [];

        for (let i = 1; i < 13; i++) {
            options.push(<option key={i} value={i}>{i}</option>);
        }

        return options;
    }

    renderTextField(field) {
        const { meta: { touched, error } } = field;
        const className = `col-md-${field.size} ${touched && error ? "has-error" : ""}`;

        return (
            <div className={className}>
                <label>{field.label}</label>
                <input type={field.type} placeholder={field.placeholder} min={field.min} max={field.max} {...field.input} />
                <span className="help-block float-left">{touched ? error : ""}</span>
            </div>
        );
    }

    renderCheckBoxField(field) {
        const { meta: { touched, error } } = field;
        const { config: { CDN } } = this.props;
        const className = `col-md-${field.size} ${touched && error ? "has-error" : ""}`;

        return (
            <div className={className}>
                <div className="input-checkbox">
                    <input className="validate-required" type="checkbox" id={field.id} {...field.input} />
                    <label htmlFor={field.id} />
                </div>
                <span className="type--italic">
                    <a href="/images/FXG CSP Software Support and Depot Services Agreement_02242022_Update.pdf" target="_blank" rel="noopener noreferrer"> <Translate value="checkout.wizard.steps.four.agreementPdfName" /></a>
                </span>
                <span className="help-block float-left">{touched ? error : ""}</span>
            </div>
        );
    }

    renderProductAgreementCheckBoxField(field) {
        const { meta: { touched, error } } = field;
        const { config: { CDN } } = this.props;
        const className = `col-md-${field.size} ${touched && error ? "has-error" : ""}`;

        return (
            <div className={className}>
                <div className="input-checkbox">
                    <input className="validate-required" type="checkbox" id={field.id} {...field.input} />
                    <label htmlFor={field.id} />
                </div>
                <span className="type--italic">
                    <a href="/images/V-Track Services Subscription Agreement - For Store_06072024_Update.pdf" target="_blank" rel="noopener noreferrer"> <Translate value="checkout.wizard.steps.four.productAgreementPdfName" /></a>
                </span>
                <span className="help-block float-left">{touched ? error : ""}</span>
            </div>
        );
    }

    renderRentalAgreementCheckBoxField(field) {
        const { meta: { touched, error } } = field;
        const className = `col-md-${field.size} ${touched && error ? "has-error" : ""}`;

        return (
            <div className={className}>
                <div className="input-checkbox">
                    <input className="validate-required" type="checkbox" id={field.id} {...field.input} />
                    <label htmlFor={field.id} />
                </div>
                <span className="type--italic">
                    <a href="/images/Rental Services Agreement.pdf" target="_blank" rel="noopener noreferrer"> <Translate value="checkout.wizard.steps.four.rentalAgreementPdfName" /></a>
                </span>
                <span className="help-block float-left">{touched ? error : ""}</span>
            </div>
        );
    }

    normalizeCreditCard(value) {
        const onlyNums = value.replace(/[^\d]/g, "");
        const card = creditCardType(onlyNums);
        const type = card[0] ? card[0].type : "visa";

        this.setState({ cardType: type });

        return Utilities.normalizeCreditCard(value);
    }

    normalizeCvv(value) {
        const { cardType } = this.state;
        return Utilities.normalizeCvv(value, cardType);
    }

    onTermsChange(e) {
        const { getXsrfToken, updateCustomerAgreement } = this.props;
        const { selectedPaymentMethod } = this.state;
        this.setState({ termsChecked: e.target.checked, canComplete: selectedPaymentMethod !== null && e.target.checked });

        getXsrfToken(({ token }) => {
            const obj = {
                __RequestVerificationToken: token,
                Agreed: e.target.checked
            };

            updateCustomerAgreement(obj);
        });
    }

    onProductTermsChange(e) {
        const { getXsrfToken, updateProductAgreement } = this.props;
        const { selectedPaymentMethod } = this.state;
        this.setState({ productTermsChecked: e.target.checked, canCompleteAgreement: selectedPaymentMethod !== null && e.target.checked });

        getXsrfToken(({ token }) => {
            const obj = {
                __RequestVerificationToken: token,
                Agreed: e.target.checked
            };

            updateProductAgreement(obj);
        });
    }

    onRentalTermsChange(e) {
        const { getXsrfToken, updateRentalAgreement } = this.props;
        const { selectedPaymentMethod } = this.state;
        this.setState({ rentalTermsChecked: e.target.checked, canCompleteRentalAgreement: selectedPaymentMethod !== null && e.target.checked });

        getXsrfToken(({ token }) => {
            const obj = {
                __RequestVerificationToken: token,
                Agreed: e.target.checked
            };

            updateRentalAgreement(obj);
        });
    }

    onPaymentMethodSelect(selectedPaymentMethod) {
        const { getXsrfToken, selectPaymentMethod } = this.props;
        const { termsChecked, productTermsChecked, rentalTermsChecked } = this.state;

        this.setState({ selectedPaymentMethod, canComplete: termsChecked, canCompleteAgreement: productTermsChecked, canCompleteRentalAgreement: rentalTermsChecked });

        getXsrfToken(({ token }) => {
            const obj = {
                __RequestVerificationToken: token,
                Method: selectedPaymentMethod
            };

            selectPaymentMethod(obj);
        });
    }

    sendPaymentDataToProcessor(values) {
        const { toggleBlockingStatus, customerPaymentMethods, config: { PAYMENT_PROCESSOR } } = this.props;
        const { selectedPaymentMethod } = this.state;
        let secureData = this.buildRequestBody(values);

        toggleBlockingStatus(true);

        if (selectedPaymentMethod === "Payments.PurchaseOrder") {
            let accountFound = this.getExistingBankAccount(values, customerPaymentMethods.bankAccounts);

            // eslint-disable-next-line no-undef
            if (PAYMENT_PROCESSOR === 1) {
                if (accountFound) {
                    const res = this.getExistingCardResponse("COMMON.ACCEPT.INAPP.PAYMENT", accountFound.Id);

                    this.responseHandler(res);
                } else {
                    // eslint-disable-next-line no-undef
                    Accept.dispatchData(secureData, this.responseHandler);
                }
            // eslint-disable-next-line no-undef
            } else if (PAYMENT_PROCESSOR === 2) {
                if (accountFound) {
                    const res = this.getExistingCardResponse("com.intuit.quickbooks.payment", accountFound.Id);

                    this.responseHandler(res);
                } else {
                    this.makeIntuitRequest(secureData);
                }
            }
        } else {
            let cardFound = this.getExistingCard(values, customerPaymentMethods.cards);

            // eslint-disable-next-line no-undef
            if (PAYMENT_PROCESSOR === 1) {
                if (cardFound) {
                    const res = this.getExistingCardResponse("COMMON.ACCEPT.INAPP.PAYMENT", cardFound.Id);

                    this.responseHandler(res);
                } else {
                    // eslint-disable-next-line no-undef
                    Accept.dispatchData(secureData, this.responseHandler);
                }
            // eslint-disable-next-line no-undef
            } else if (PAYMENT_PROCESSOR === 2) {
                if (cardFound) {
                    const res = this.getExistingCardResponse("com.intuit.quickbooks.payment", cardFound.Id);

                    this.responseHandler(res);
                } else {
                    this.makeIntuitRequest(secureData);
                }
            }
        }
    }

    buildRequestBody(values) {
        const { change, config: { PAYMENT_PROCESSOR, AUTHORIZENET_PUBLIC_CLIENT_KEY, AUTHORIZENET_API_LOGIN_ID } } = this.props;
        const { selectedPaymentMethod } = this.state;
        let secureData;
        let cardData;
        let bankData;

        if (selectedPaymentMethod === "Payments.PurchaseOrder") {
            if (!values.AccountType) {
                values.AccountType = document.getElementsByName("AccountType")[0].value;
                change("AccountType", values.AccountType);
            }

            // eslint-disable-next-line no-undef
            if (PAYMENT_PROCESSOR === 1) {
                const authData = {
                    // eslint-disable-next-line no-undef
                    clientKey: AUTHORIZENET_PUBLIC_CLIENT_KEY,
                    // eslint-disable-next-line no-undef
                    apiLoginID: AUTHORIZENET_API_LOGIN_ID
                };

                bankData = {
                    accountNumber: values.AccountNumber,
                    routingNumber: values.RoutingNumber,
                    nameOnAccount: values.NameOnAccount,
                    accountType: values.AccountType
                };

                secureData = { authData, bankData };
            // eslint-disable-next-line no-undef
            } else if (PAYMENT_PROCESSOR === 2) {
                bankData = {
                    accountNumber: values.AccountNumber,
                    routingNumber: values.RoutingNumber,
                    name: values.NameOnAccount,
                    accountType: values.AccountType === "savings" ? "PERSONAL_SAVINGS" : "PERSONAL_CHECKING",
                    phone: values.Billing_PhoneNumber || "1234567890"
                };

                secureData = { bankAccount: bankData };
            }
        } else {
            const cardNumber = values.CardNumber.replace(/ /g, "");

            if (!values.ExpireMonth) {
                values.ExpireMonth = document.getElementsByName("ExpireMonth")[0].value;
                change("ExpireMonth", values.ExpireMonth);
            }

            if (!values.ExpireYear) {
                values.ExpireYear = document.getElementsByName("ExpireYear")[0].value;
                change("ExpireYear", values.ExpireYear);
            }

            // eslint-disable-next-line no-undef
            if (PAYMENT_PROCESSOR === 1) {
                const authData = {
                    // eslint-disable-next-line no-undef
                    clientKey: AUTHORIZENET_PUBLIC_CLIENT_KEY,
                    // eslint-disable-next-line no-undef
                    apiLoginID: AUTHORIZENET_API_LOGIN_ID
                };

                cardData = {
                    fullName: values.CardholderName,
                    cardNumber: cardNumber,
                    month: values.ExpireMonth,
                    year: values.ExpireYear,
                    cardCode: values.CardCode
                };

                secureData = { authData, cardData };
            // eslint-disable-next-line no-undef
            } else if (PAYMENT_PROCESSOR === 2) {
                cardData = {
                    name: values.CardholderName,
                    number: cardNumber,
                    expMonth: parseInt(values.ExpireMonth) < 10 ? `0${values.ExpireMonth}` : values.ExpireMonth,
                    expYear: values.ExpireYear,
                    cvc: values.CardCode
                    // Address: {
                    //     StreetAddress: values.Billing_Address1,
                    //     City: values.Billing_City,
                    //     Region: _.find(states, s => s.stateId === values.Billing_StateId).stateName,
                    //     PostalCode: values.Billing_ZipPostalCode,
                    // }
                };

                secureData = { card: cardData };
            }
        }

        return secureData;
    }

    getExistingCard(values, cards) {
        const { cardType } = this.state;
        const cardNumber = values.CardNumber.replace(/ /g, "");
        const enteredCardLastFour = cardNumber.substr(cardNumber.length - 4);

        return _.find(cards, card => {
            const lastFour = card.number.substr(card.number.length - 4);

            return enteredCardLastFour === lastFour &&
                cardType.toLowerCase() === card.cardType.toLowerCase() &&
                parseInt(values.ExpireMonth) === parseInt(card.expMonth) &&
                parseInt(values.ExpireYear) === parseInt(card.expYear);
        });
    }

    getExistingBankAccount(values, bankAccounts) {
        const accountNumber = values.AccountNumber.replace(/ /g, "");
        const routingNumber = values.RoutingNumber.replace(/ /g, "");
        const enteredAccountLastFour = accountNumber.substr(accountNumber.length - 4);
        const enteredRoutingLastFour = routingNumber.substr(routingNumber.length - 4);
        const accountType = document.getElementsByName("AccountType")[0].options[document.getElementsByName("AccountType")[0].selectedIndex].text;

        return _.find(bankAccounts, bankAccount => {
            const lastAccountFour = bankAccount.accountNumber.substr(bankAccount.accountNumber.length - 4);
            const lastRoutingFour = bankAccount.routingNumber.substr(bankAccount.routingNumber.length - 4);

            return enteredAccountLastFour === lastAccountFour &&
                enteredRoutingLastFour === lastRoutingFour &&
                accountType.toLowerCase() === bankAccount.accountType.toLowerCase();
        });
    }

    getExistingCardResponse(descriptor, cardId) {
        return {
            messages: {
                resultCode: "Success"
            },
            opaqueData: {
                dataDescriptor: descriptor,
                cardId: cardId,
                isNotToken: true
            }
        };
    }

    makeIntuitRequest(secureData) {
        const { toggleBlockingStatus, config: { INTUIT_PAYMENTS_BASE_URL } } = this.props;

        // eslint-disable-next-line no-undef
        fetch(`${INTUIT_PAYMENTS_BASE_URL}/quickbooks/v4/payments/tokens`, {
            method: "POST",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(secureData)
        })
            .then(response => {
                if (!response.ok) {
                    throw response;
                }

                return response.json();
            })
            .then(data => {
                let res;

                if (data.errors && data.errors.length > 0) {
                    res = {
                        messages: {
                            resultCode: "Error",
                            message: _.map(data.errors, err => {
                                return {
                                    code: err.code,
                                    text: err.message
                                };
                            })
                        }
                    };
                } else {
                    res = {
                        messages  : {
                            resultCode: "Success"
                        },
                        opaqueData: {
                            dataDescriptor: "com.intuit.quickbooks.payment",
                            dataValue     : data.value,
                            isNotToken    : false
                        }
                    };
                }

                this.responseHandler(res);
            })
            .catch(error => {
                toggleBlockingStatus(false);
                document.querySelector("#server-error-msg").textContent = I18n.t("alerts.paymentError");
                $("#server-error-modal").modal("show");
            });
    }

    responseHandler(response) {
        const { toggleBlockingStatus, onFinish, paymentFailed, wizardName, currentApprovalCode } = this.props;
        const { selectedPaymentMethod } = this.state;

        if (response.messages.resultCode === "Error") {
            paymentFailed({
                response: {
                    data: response.messages.message[0].text
                }
            });
            toggleBlockingStatus(false);
        } else {
            const obj = {
                PaymentToken: {
                    Description: response.opaqueData.dataDescriptor,
                    Token: response.opaqueData.dataValue,
                    CardId: response.opaqueData.cardId,
                    IsNotToken: response.opaqueData.isNotToken,
                    Card: selectedPaymentMethod !== "Payments.PurchaseOrder"
                }
            };

            if (wizardName === "Lease") {
                obj.ApprovalCode = currentApprovalCode.approvalCode;
            }

            onFinish(obj);

            this.resetForm();
        }
    }

    renderErrors() {
        const { paymentStatus, leaseStatus, toggleBlockingStatus } = this.props;
        let data = null;

        if (paymentStatus.response) {
            // eslint-disable-next-line prefer-destructuring
            data = paymentStatus.response.data;
        } else if (leaseStatus.response) {
            // eslint-disable-next-line prefer-destructuring
            data = leaseStatus.response.data;
        }

        if (data) {
            toggleBlockingStatus(false);

            return (
                <div className="row justify-content-md-center" style={{ marginTop: 20 }}>
                    <div className="col-md-8">
                        <div className="alert bg--error" style={{ marginBottom: 0 }}>
                            <div className="alert__body">
                                <span>{data}</span>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }

    render() {
        const { handleSubmit, wizards, wizardName, goPrev, productNeedsAgreement, rentalNeedsAgreement } = this.props;
        const { selectedPaymentMethod, canComplete, canCompleteAgreement, canCompleteRentalAgreement } = this.state;
        const wizard = wizards[wizardName];

        let currentStep = 1;
        let totalSteps = 1;

        if (wizard) {
            // eslint-disable-next-line prefer-destructuring
            currentStep = wizard.currentStep;
            // eslint-disable-next-line prefer-destructuring
            totalSteps = wizard.totalSteps;
        }

        return (
            <form className="container" onSubmit={handleSubmit(this.sendPaymentDataToProcessor.bind(this))}>
                <div className="row justify-content-around" style={{ marginBottom: 20 }}>
                    <div className="col-md-10">
                        <ul>
                            <li className="type--italic"><Translate value="checkout.wizard.steps.four.message" /></li>
                        </ul>
                    </div>
                </div>
                <div className="row justify-content-md-center">
                    <div className="col-md-6">
                        <div className="row paymentMethods">
                            {this.renderPaymentMethods()}
                        </div>
                    </div>
                </div>
                <div className="row" style={{ marginTop: 20 }}>
                    <div className="col-md-12">
                        {selectedPaymentMethod === "Payments.PurchaseOrder" &&
                        <div className="row">
                            <div className="col-12">
                                <div className="row justify-content-md-center" style={{ marginBottom: 20 }}>
                                    <div className="col-md-8 text-center">
                                        <img alt="Check" className="border--round" src={require("../../../../Assets/Images/img-check.png")} />
                                    </div>
                                </div>
                                <div className="row justify-content-md-center">
                                    <Field
                                        name="RoutingNumber"
                                        type="text"
                                        label={I18n.t("bankAccount.routingNumber")}
                                        placeholder={I18n.t("bankAccount.routingNumber")}
                                        size="4"
                                        normalize={Utilities.normalizeABA}
                                        component={this.renderTextField}
                                    />
                                    <Field
                                        name="AccountNumber"
                                        type="text"
                                        label={I18n.t("bankAccount.accountNumber")}
                                        placeholder={I18n.t("bankAccount.accountNumber")}
                                        size="4"
                                        normalize={Utilities.normalizeACH}
                                        component={this.renderTextField}
                                    />
                                </div>
                                <div className="row justify-content-md-center">
                                    <Field
                                        name="NameOnAccount"
                                        type="text"
                                        label={I18n.t("bankAccount.name")}
                                        placeholder={I18n.t("bankAccount.name")}
                                        size="4"
                                        normalize={Utilities.normalizeAccountName}
                                        component={this.renderTextField}
                                    />
                                    <div className="col-md-4">
                                        <label><Translate value="bankAccount.type" /></label>
                                        <div className="input-select">
                                            <Field name="AccountType" component="select">
                                                <option value="checking">{I18n.t("bankAccount.typeOptions.checking")}</option>
                                                <option value="savings">{I18n.t("bankAccount.typeOptions.savings")}</option>
                                            </Field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}

                        {selectedPaymentMethod === "Payments.Manual" &&
                        <div className="row">
                            <div className="col-12">
                                <div className="row justify-content-md-center">
                                    <Field
                                        name="CardholderName"
                                        type="text"
                                        label={I18n.t("creditCard.name")}
                                        placeholder={I18n.t("creditCard.name")}
                                        size="8"
                                        component={this.renderTextField}
                                    />
                                </div>
                                <div className="row justify-content-md-center">
                                    <Field
                                        name="CardNumber"
                                        type="text"
                                        label={I18n.t("creditCard.cardNumber")}
                                        placeholder={I18n.t("creditCard.cardNumber")}
                                        size="4"
                                        normalize={this.normalizeCreditCard}
                                        component={this.renderTextField}
                                    />
                                    <Field
                                        name="CardCode"
                                        type="password"
                                        label={I18n.t("creditCard.code")}
                                        placeholder={I18n.t("creditCard.code")}
                                        size="4"
                                        normalize={this.normalizeCvv}
                                        component={this.renderTextField}
                                    />
                                </div>
                                <div className="row justify-content-md-center">
                                    <div className="col-md-4">
                                        <label><Translate value="creditCard.expMonth" /></label>
                                        <div className="input-select">
                                            <Field name="ExpireMonth" component="select">
                                                {this.renderMonths()}
                                            </Field>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <label><Translate value="creditCard.expYear" /></label>
                                        <div className="input-select">
                                            <Field name="ExpireYear" component="select">
                                                {this.renderYears()}
                                            </Field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}

                        {this.renderErrors()}
                    </div>
                </div>

                <div className="row justify-content-around" style={{ marginTop: 20 }}>
                    <span className="type--italic" style={{display: "inline", whiteSpace: "normal"}}><Translate value="checkout.wizard.steps.four.agreement" /></span>
                </div>
                <div className="row">
                    <div className="col"></div>
                    <Field
                        name="Terms"
                        id="terms"
                        size="5"
                        onChange={this.onTermsChange}
                        component={this.renderCheckBoxField}
                    />
                    <div className="col"></div>
                </div>
                
                {productNeedsAgreement &&
                    <div className="row">
                        <div className="col"></div>
                        <Field
                            name="ProductTerms"
                            id="productTerms"
                            size="5"
                            onChange={this.onProductTermsChange}
                            component={this.renderProductAgreementCheckBoxField}
                        />
                    <div className="col"></div>
                    </div>
                    }
                {rentalNeedsAgreement &&
                    <div className="row">
                    <div className="col"></div>
                        <Field
                            name="RentalTerms"
                            id="rentalTerms"
                            size="5"
                            onChange={this.onRentalTermsChange}
                            component={this.renderRentalAgreementCheckBoxField}
                        />
                    <div className="col"></div>
                    </div>
                    }

                <Field type="hidden" name="DataDescriptor" component="input"/>
                <Field type="hidden" name="DataValue" component="input"/>
                <Field type="hidden" name="CardId" component="input"/>
                <Field type="hidden" name="IsNotToken" component="input"/>
                <Field type="hidden" name="Card" component="input"/>

                {currentStep === totalSteps
                    ? <WizardActionButtons showPrev={true} showFinish={true} finishLabel={I18n.t("misc.complete")} btnDisabled={productNeedsAgreement && rentalNeedsAgreement ? (!canComplete || !canCompleteAgreement || !canCompleteRentalAgreement) : productNeedsAgreement ? (!canComplete || !canCompleteAgreement) : rentalNeedsAgreement ? (!canComplete || !canCompleteRentalAgreement) : !canComplete} goPrev={goPrev} wizardName={wizardName} />
                    : <WizardActionButtons showPrev={true} showNext={true} btnDisabled={productNeedsAgreement && rentalNeedsAgreement ? (!canComplete || !canCompleteAgreement || !canCompleteRentalAgreement) : productNeedsAgreement ? (!canComplete || !canCompleteAgreement) : rentalNeedsAgreement ? (!canComplete || !canCompleteRentalAgreement) : !canComplete} wizardName={wizardName}/>}
            </form>
        );
    }
}

PaymentMethodForm.propTypes = {
    getXsrfToken: PropTypes.func,
    selectPaymentMethod: PropTypes.func,
    updateCustomerAgreement: PropTypes.func,
    toggleBlockingStatus: PropTypes.func,
    paymentFailed: PropTypes.func,
    resetCurrentApprovalCode: PropTypes.func,
    change: PropTypes.func,
    untouch: PropTypes.func,
    handleSubmit: PropTypes.func,
    goPrev: PropTypes.func,
    onFinish: PropTypes.func,
    wizardName: PropTypes.string,
    productNeedsAgreement: PropTypes.bool,
    rentalNeedsAgreement: PropTypes.bool,
    i18n: PropTypes.object,
    states: PropTypes.array,
    customerPaymentMethods: PropTypes.object,
    paymentMethods: PropTypes.array,
    paymentStatus: PropTypes.object,
    leaseStatus: PropTypes.object,
    wizards: PropTypes.object,
    userInfo: PropTypes.object,
    currentApprovalCode: PropTypes.object,
    config: PropTypes.object,
    history: PropTypes.object
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        config: state.config,
        states: state.states,
        customerPaymentMethods: state.customerPaymentMethods,
        paymentMethods: state.paymentMethods,
        paymentStatus: state.paymentStatus,
        leaseStatus: state.leaseStatus,
        wizards: state.wizards,
        userInfo: state.userInfo,
        currentApprovalCode: state.currentApprovalCode
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken: getXsrfToken,
        selectPaymentMethod: selectPaymentMethod,
        updateCustomerAgreement: updateCustomerAgreement,
        updateProductAgreement: updateProductAgreement,
        updateRentalAgreement: updateRentalAgreement,
        toggleBlockingStatus: toggleBlockingStatus,
        paymentFailed: paymentFailed,
        resetCurrentApprovalCode: resetCurrentApprovalCode
    }, dispatch)
}

function validate(values) {
    const errors = {};

    if (!values.CardNumber) {
        errors.CardNumber = I18n.t("validation.creditCard.cardNumber.required");
    }
    if (!values.CardholderName) {
        errors.CardholderName = I18n.t("validation.creditCard.name.required");
    }
    if (!values.CardCode) {
        errors.CardCode = I18n.t("validation.creditCard.code.required");
    }

    if (!values.RoutingNumber) {
        errors.RoutingNumber = I18n.t("validation.bankAccount.routingNumber.required");
    }
    if (!values.AccountNumber) {
        errors.AccountNumber = I18n.t("validation.bankAccount.accountNumber.required");
    }
    if (!values.NameOnAccount) {
        errors.NameOnAccount = I18n.t("validation.bankAccount.name.required");
    }

    if (!values.Terms) {
        errors.Terms = I18n.t("validation.bankAccount.terms.required");
    }

    return errors;
}

export default reduxForm({
    validate,
    form: "CheckoutForm",
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(
    connect(mapStateToProps, mapDispatchToProps)(PaymentMethodForm)
);